import React from "react";
import "./App.css";
import "./components/react-select-search/style.css";
import PageBody from "./PageBody";
import NavContainer from "./NavContainer";
import SearchContainer from "./SearchContainer";
import { Translation } from "react-i18next";
import AppCollection from "./AppCollection";

const app_collection_attribute_list = [
  {
    href: "https://www.databot-app.com/",
    category: "AI",
    imgsrc:
      "https://is2-ssl.mzstatic.com/image/thumb/Purple124/v4/8a/e8/98/8ae89820-8eba-c5a3-9deb-62eee49c2f48/AppIcon-0-0-1x_U007emarketing-0-0-0-5-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/434x0w.webp",
    name: "DataBot 助理 - 人工智能",
    brand: "Apple",
  },
  {
    href: "/apps/alpa",
    category: "AI",
    imgsrc: "https://api-cdn.zhink.cn/app%2Ficon128x128_c2kdgb.png",
    name: "Excel (OpenAI Tabulate)",
    brand: "GPT",
  },
  {
    href: "https://www.databot-app.com/",
    category: "AI",
    imgsrc:
      "https://is2-ssl.mzstatic.com/image/thumb/Purple126/v4/29/cc/fe/29ccfe67-cb01-3e3c-5c94-0a5d990d1189/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/434x0w.webp",
    name: "讯飞听见字幕",
    brand: "Apple",
  },
  {
    href: "https://erp-demo.zhink.cn:8443/partymgr/control/login",
    category: "ERP",
    imgsrc:
      "https://is2-ssl.mzstatic.com/image/thumb/Purple126/v4/29/cc/fe/29ccfe67-cb01-3e3c-5c94-0a5d990d1189/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/434x0w.webp",
    name: "ERP简易",
    brand: "Apple",
  },
];

class App extends React.Component {
  saveInput = () => {
    console.log("@");
  };
  showData = () => {
    alert(this);
  };
  render() {
    const ref = React.createRef();

    return (
      <div id="__next">
        <main className="home-page">
          <div className="content-container">
            <div className="masthead">
              <NavContainer />
              <SearchContainer />
              <div></div>
              <div className="menu-container-branding">
                {/* <span>
                  <img src="https://s.alicdn.com/@img/tfs/TB1hVGkvVP7gK0jSZFjXXc5aXXa-365-49.svg"
                    style={{ "width": "216px" }}
                    alt="" title="" /></span>

                <span>
                  <img src="https://api-cdn.zhink.cn/shopify.png"
                    style={{ "width": "216px" }}
                    alt="" title="" /></span>

                <span>
                  <img src="https://api-cdn.zhink.cn/tiktokshop.png"
                    style={{ "width": "216px" }}
                    alt="" title="" /></span> */}

                <div className="page-content-container">
                  {/* <div className="listings">
                                <div className="grid-section-header" id="New">
                                    <div className="fr all-link"><a href="/collection/new">
                                        <Translation>
                                            {(t) => <span className="arrow">{t("about.see-all")}→</span>}
                                        </Translation>
                                    </a></div>
                                    <h4>New</h4>
                                    <h3>
                                        <p>Recently added apps</p>
                                    </h3>
                                </div>
                                <AppCollection name="new app" attribute={new_collection_attribute_list} />
                            </div> */}
                  <div className="listings">
                    <AppCollection
                      name="popular app"
                      attribute={app_collection_attribute_list}
                    />
                    <div className="grid-section-side-bar"></div>
                    <div className="grid-section-header" id="Popular">
                      <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2">
                        <div className="MuiGrid-button"><img alt='hi' className="chevron left" src="https://assets.msn.com/staticsb/statics/latest/icons-wc/icons/ChevronLeft.svg"/></div>
                        <div className="MuiGrid-button"><img alt='wo' className="chevron left" src="https://assets.msn.com/staticsb/statics/latest/icons-wc/icons/ChevronRight.svg"/></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <PageBody className="pageBody" />
          </div>
        </main>
        <div>
          <footer data-testid="footer">
            <div className="max-width-container">
              <div className="footer-container">
                <ul className="menu">
                  <li>
                    <a data-testid="footer-item" href="https://zhink.cn/">
                      The Zhink logo are the property of Zhink.cn
                    </a>
                  </li>
                  <li>
                    <a data-testid="footer-item" href="zhink.cn/yx.txt">
                      Copyright © zhink.com
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://beian.miit.gov.cn/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      浙ICP备2023001279号
                    </a>
                  </li>
                </ul>
                <div className="footer-right-container">
                  <ul className="menu">
                    <li>
                      <a data-testid="footer-item" href="zhink.cn/yx.txt">
                        Zhink AI隐私政策
                      </a>
                    </li>
                    <li>
                      <a data-testid="footer-item" href="zhink.cn/yx.txt">
                        XK隐私政策
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    );
  }
}

export default App;
